import * as R from 'ramda';
import { httpGet, httpPost, httpPut } from 'apiModule/rest';
import adapter from 'dataModule/adapter';
import { getQueriesString, getIdsObject } from 'utilsModule';

const getAdtVisitTypeOptions = async () => R.pipe(
  () => httpGet('adt/visitTypes'),
  response => response.then(adapter.adt.getAdtVisitTypeOptions.be2fe),
)();

const getAdtVisitOccurrenceOptions = async () => R.pipe(
  () => httpGet('adt/visitOccurrenceTypes'),
  response => response.then(adapter.adt.getAdtVisitOccurrenceOptions.be2fe),
)();

const saveAdtHistory = async ({ content }) => R.pipe(
  adapter.adt.saveAdtHistory.fe2be,
  httpPost('adt/adtHistory'),
  response => response.then(adapter.adt.saveAdtHistory.be2fe),
)(content);

const updateAdtHistory = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ adtRecordId }) => `adt/adtHistory/${adtRecordId}`)(ids);

  return R.pipe(adapter.adt.updateAdtHistory.fe2be, httpPut(url), (response) =>
    response.then(adapter.adt.updateAdtHistory.be2fe),
  )(content);
};

const getAdtHistory = async ({ params: { queries } }) => {
  return R.pipe(
    getQueriesString,
    queriesString => httpGet(`adt/adtHistory${queriesString}`),
    response => response.then(adapter.adt.getAdtHistory.be2fe),
  )(queries);
};

const deleteAdtHistory = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ adtRecordId }) => `adt/adtHistory/${adtRecordId}/delete`)(ids);

  return R.pipe(adapter.adt.deleteAdtHistory.fe2be, httpPut(url), (response) =>
    response.then(adapter.adt.deleteAdtHistory.be2fe),
  )(content);
};

const archiveAdtHistory = async ({ content, params: { ids } }) => {
  const url = R.pipe(getIdsObject, ({ adtRecordId }) => `adt/adtHistory/${adtRecordId}/archive`)(ids);

  return R.pipe(adapter.adt.archiveAdtHistory.fe2be, httpPut(url), (response) =>
    response.then(adapter.adt.archiveAdtHistory.be2fe),
  )(content);
};

const addAdtNote = async ({ content }) =>
  R.pipe(adapter.adt.addAdtNote.fe2be, httpPost('adt/adtHistory/note'), (response) =>
    response.then(adapter.adt.addAdtNote.be2fe),
  )(content);

const getAdtNotes = async ({ params: { queries } }) => {
  return R.pipe(
    getQueriesString,
    (queriesString) => httpGet(`adt/adtHistory/note${queriesString}`),
    (response) => response.then(adapter.adt.getAdtNotes.be2fe),
  )(queries);
};

const markAdtNoteAsError = async ({ content }) =>
  R.pipe(adapter.adt.markAdtNoteAsError.fe2be, httpPost('adt/adtHistory/note/markNoteAsError'), (response) =>
    response.then(adapter.adt.markAdtNoteAsError.be2fe),
  )(content);

const DM = {
  getAdtVisitTypeOptions,
  getAdtVisitOccurrenceOptions,
  saveAdtHistory,
  updateAdtHistory,
  getAdtHistory,
  deleteAdtHistory,
  archiveAdtHistory,
  addAdtNote,
  getAdtNotes,
  markAdtNoteAsError
};

const ajax = async ({ method, input }) => ({ [method]: await DM[method](input) });

export default { ...DM, ajax };
